import { MessageSquare, Sparkles, Star } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateReplyingToTrustpilotReviewsAr: TemplateAr = {
  name: 'أتمتة الرد على تقييمات Trustpilot بالذكاء الاصطناعي',
  description:
    'رد على تقييمات Trustpilot تلقائياً بردود مخصصة وبصوت علامتك. الذكاء الاصطناعي يصيغ الرد المناسب حسب نبرة التقييم ومحتواه.',
  category: 'دعم العملاء',
  workflow: [
    { icon: Star, label: 'تقييم' },
    { icon: Sparkles, label: 'صياغة ذكية' },
    { icon: MessageSquare, label: 'تم إرسال الرد', final: true },
  ],
  detailDescription: {
    paragraph1:
      'رد على كل تقييم Trustpilot بصوت علامتك، مو بقالب واحد مكرر. الـ AI يقرأ التقييم، ويفهم المشاعر والملاحظة اللي فيه بالضبط، ويصيغ رداً يعالج وش يهم العميل. والتقييم الإيجابي له شكر وتعزيز، والسلبي له إقرار وطرح حلول.',
    paragraph2:
      'الرد ينشر تلقائياً، أو يوقف في طابور الاعتماد، حسب النبرة والمحتوى. والمسودات ومسارات الاعتماد والردود المنشورة تلقاها في Slack أو الإيميل أو لوحة إدارة التقييمات عندك. والـ AI يتعلّم صوت علامتك وأنماط ردودك عشان تبقى متسقة.',
  },
  benefits: [
    'رد بسرعة على كل تقييم',
    'صوت علامتك يبقى ثابت في كل رد',
    'التقييم السلبي يتحوّل لفرصة حل',
    'وفّر ساعات من إدارة التقييمات يدوياً',
    'تقييماتك العامة ترتفع',
    'العميل يحس إن صوته مسموع',
  ],
};
